import { styled } from "styled-components";

export const DropdownMenu = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 8px 0;
  width: 100%;
  max-height: 120px;
  overflow-y: auto;
  z-index: 1;
`;
